(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initBand = (band) => {
    if (band.dataset.ready) return;
    band.dataset.ready = '1';

    const btn = band.querySelector('[data-mats-marquee-toggle]');
    const label = btn?.querySelector('[data-label]');
    const videos = [...band.querySelectorAll('video')];
    const mobileQuery = window.matchMedia('(max-width: 699px)');
    let visible = false;

    // Si hay vídeo de móvil, en < 700px se usa ese; si no, siempre el principal
    const activeVideo = () => {
      const mobile = videos.find((v) => v.classList.contains('is-mobile'));
      const desktop = videos.find((v) => !v.classList.contains('is-mobile'));
      return mobile && mobileQuery.matches ? mobile : desktop || mobile;
    };

    videos.forEach((v) => {
      v.muted = true; // necesario para autoplay en iOS
      v.setAttribute('muted', '');
    });

    const syncVideo = () => {
      const current = activeVideo();
      videos.forEach((v) => {
        if (v !== current) return v.pause();
        const shouldPlay = visible && !band.classList.contains('is-paused');
        if (shouldPlay) {
          if (v.preload === 'none') v.preload = 'auto'; // empieza a descargar solo cuando hace falta
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    };

    mobileQuery.addEventListener?.('change', syncVideo);

    const setPaused = (paused) => {
      band.classList.toggle('is-paused', paused);
      if (btn) {
        btn.setAttribute('aria-pressed', String(paused));
        if (label) label.textContent = paused ? btn.dataset.playLabel : btn.dataset.pauseLabel;
      }
      syncVideo();
    };

    // Marquesina: velocidad constante en px/s y sin huecos en pantallas anchas
    const marquee = band.querySelector('.mats-footer__marquee');
    const track = band.querySelector('.mats-footer__track');
    const speed = parseFloat(band.dataset.speed) || 45;

    const layout = () => {
      if (!marquee || !track) return;
      const groups = track.querySelectorAll('.mats-footer__group');
      const first = groups[0];
      if (!first) return;

      const groupWidth = first.getBoundingClientRect().width;
      if (!groupWidth) return;

      // Hacen falta grupos suficientes para cubrir el ancho visible + uno que entra
      const needed = Math.max(2, Math.ceil(marquee.clientWidth / groupWidth) + 1);
      for (let i = groups.length; i < needed; i++) {
        const clone = first.cloneNode(true);
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        track.appendChild(clone);
      }

      track.style.setProperty('--mats-marquee-shift', `${groupWidth}px`);
      track.style.setProperty('--mats-marquee-duration', `${groupWidth / speed}s`);
    };

    layout();
    document.fonts?.ready.then(layout);
    if ('ResizeObserver' in window && marquee) {
      let raf;
      new ResizeObserver(() => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(layout);
      }).observe(marquee);
    }

    setPaused(reduceMotion.matches);
    btn?.addEventListener('click', () => setPaused(!band.classList.contains('is-paused')));

    // El vídeo solo se descarga y reproduce cuando la banda está cerca de la pantalla
    if (videos.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        syncVideo();
      }, { rootMargin: '300px 0px' }).observe(band);
    } else {
      visible = true;
      syncVideo();
    }
  };

  const initCookies = (link) => {
    if (link.dataset.ready) return;
    link.dataset.ready = '1';
    link.addEventListener('click', (e) => {
      // Banner de cookies nativo de Shopify; si no está activo, el enlace lleva a la política
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        e.preventDefault();
        window.privacyBanner.showPreferences();
      }
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-mats-marquee]').forEach(initBand);
    root.querySelectorAll('[data-mats-cookie-prefs]').forEach(initCookies);
  };

  // Cerrar selector de país/idioma: clic fuera o Escape
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.mats-locale[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mats-locale[open]').forEach((d) => {
      d.removeAttribute('open');
      d.querySelector('summary')?.focus();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
